export function getFilterFromSearchParams(searchParams = {}) {
  return {
    keyword: searchParams.keyword || '',
    platforms: searchParams.platforms
      ? String(searchParams.platforms).split(',')
      : ['Any'],
    game: searchParams.game || 'Any',
    days: searchParams.days ? String(searchParams.days).split(',') : ['Any'],
    type: searchParams.type || 'Any',
    sort: searchParams.sort || 'Any',
    carClasses: searchParams.carClasses
      ? String(searchParams.carClasses).split(',')
      : ['Any'],
  }
}

export function buildSearchParamsFromFilter(filter, page = 1) {
  const params = new globalThis.URLSearchParams()

  if (filter.keyword) params.set('keyword', filter.keyword)
  if (filter.game && filter.game !== 'Any') params.set('game', filter.game)
  if (filter.type && filter.type !== 'Any') params.set('type', filter.type)
  if (filter.sort && filter.sort !== 'Any') params.set('sort', filter.sort)

  if (Array.isArray(filter.platforms) && filter.platforms[0] !== 'Any') {
    params.set('platforms', filter.platforms.join(','))
  }
  if (Array.isArray(filter.days) && filter.days[0] !== 'Any') {
    params.set('days', filter.days.join(','))
  }
  if (Array.isArray(filter.carClasses) && filter.carClasses[0] !== 'Any') {
    params.set('carClasses', filter.carClasses.join(','))
  }

  params.set('page', String(page))
  return params
}

export function resetUnavailableCarClasses(filter, games = []) {
  if (
    !filter.game ||
    filter.game === 'Any' ||
    !filter.carClasses?.length ||
    filter.carClasses[0] === 'Any'
  ) {
    return filter
  }

  const gameCarClasses =
    games.find((game) => game.name === filter.game)?.carClasses || []
  const hasUnavailableCarClass = filter.carClasses.some(
    (carClass) =>
      !gameCarClasses.some((available) => available.name === carClass),
  )

  if (!hasUnavailableCarClass) return filter

  return {
    ...filter,
    carClasses: ['Any'],
  }
}

export function combineEventsWithAds(events, ads = []) {
  if (!events?.length) return []

  if (!ads.length) {
    return events.map((event) => ({
      type: 'event',
      data: event,
      key: `event-${event.id}`,
    }))
  }

  const result = []
  let adIndex = 0

  for (let index = 0; index < events.length; index += 1) {
    result.push({
      type: 'event',
      data: events[index],
      key: `event-${events[index].id}`,
    })

    const shouldInsertAd =
      events.length === 1 || index === 1 || (index > 1 && (index - 1) % 4 === 0)
    if (!shouldInsertAd) continue

    result.push({
      type: 'ad',
      data: ads[adIndex % ads.length],
      key: `ad-${adIndex}-${index}`,
      placement: 'racing-search',
    })
    adIndex += 1
  }

  return result
}
